import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage } from '../../../Redux/Slices/generalSlice';


/* Screens Import */
import WelcomeScreen from '../../CommonScreens/WelcomeScreen/WelcomeScree';
import Frame24 from '../../Episode2/Frame24/Frame24';
import Frame25 from '../../Episode2/Frame25/Frame25';
import Frame26 from '../../Episode2/Frame26/Frame26';
import Frame27 from '../../Episode2/Frame27/Frame27';
import Frame28 from '../../Episode2/Frame28/Frame28';
import Frame29 from '../../Episode2/Frame29/Frame29'; // question
import Frame30 from '../../Episode2/Frame30/Frame30'; // response
import Frame31 from '../../Episode2/Frame31/Frame31';
import Frame32 from '../../Episode2/Frame32/Frame32';
import Frame33 from '../../Episode2/Frame33/Frame33';
import Frame34 from '../../Episode2/Frame34/Frame34';
import Frame35 from '../../Episode2/Frame35/Frame35';
import Frame36 from '../../Episode2/Frame36/Frame36';
import Frame37 from '../../Episode2/Frame37/Frame37';
import Frame38 from '../../Episode2/Frame38/Frame38';
import Frame39 from '../../Episode2/Frame39/Frame39';
import Frame40 from '../../Episode2/Frame40/Frame40';
import Frame41 from '../../Episode2/Frame41/Frame41';
import Frame42 from '../../Episode2/Frame42/Frame42';
import Frame43 from '../../Episode2/Frame43/Frame43';
import Frame44 from '../../Episode2/Frame44/Frame44';
import Frame45 from '../../Episode2/Frame45/Frame45';
import Frame46 from '../../Episode2/Frame46/Frame46';
import Frame47 from '../../Episode2/Frame47/Frame47';
import Frame48 from '../../Episode2/Frame48/Frame48';
import Frame49 from '../../Episode2/Frame49/Frame49';
import Frame50 from '../../Episode2/Frame50/Frame50';


function Episode2_MainPage() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);

    if (pageNo === 27) {
        return (
            <div>
                <WelcomeScreen />
            </div>
        )
    } else if (pageNo === 28) {
        return (
            <div>
                <Frame24 />
            </div>
        )
    } else if (pageNo === 29) {
        return (
            <div>
                <Frame25 />
            </div>
        )
    } else if (pageNo === 30) {
        return (
            <div>
                <Frame26 />
            </div>
        )
    } else if (pageNo === 31) {
        return (
            <div>
                <Frame27 />
            </div>
        )
    } else if (pageNo === 32) {
        return (
            <div>
                <Frame28 />
            </div>
        )
    } else if (pageNo === 33) {
        return (
            <div>
                <Frame29 />
            </div>
        )
    } else if (pageNo === 34) {
        return (
            <div>
                <Frame30 />
            </div>
        )
    } else if (pageNo === 35) {
        return (
            <div>
                <Frame31 />
            </div>
        )
    } else if (pageNo === 36) {
        return (
            <div>
                <Frame32 />
            </div>
        )
    } else if (pageNo === 37) {
        return (
            <div>
                <Frame33 />
            </div>
        )
    } else if (pageNo === 38) {
        return (
            <div>
                <Frame34 />
            </div>
        )
    } else if (pageNo === 39) {
        return (
            <div>
                <Frame35 />
            </div>
        )
    } else if (pageNo === 40) {
        return (
            <div>
                <Frame36 />
            </div>
        )
    } else if (pageNo === 41) {
        return (
            <div>
                <Frame37 />
            </div>
        )
    } else if (pageNo === 42) {
        return (
            <div>
                <Frame38 />
            </div>
        )
    } else if (pageNo === 43) {
        return (
            <div>
                <Frame39 />
            </div>
        )
    } else if (pageNo === 44) {
        return (
            <div>
                <Frame40 />
            </div>
        )
    } else if (pageNo === 45) {
        return (
            <div>
                <Frame41 />
            </div>
        )
    } else if (pageNo === 46) {
        return (
            <div>
                <Frame42 />
            </div>
        )
    } else if (pageNo === 47) {
        return (
            <div>
                <Frame43 />
            </div>
        )
    } else if (pageNo === 48) {
        return (
            <div>
                <Frame44 />
            </div>
        )
    } else if (pageNo === 49) {
        return (
            <div>
                <Frame45 />
            </div>
        )
    } else if (pageNo === 50) {
        return (
            <div>
                <Frame46 />
            </div>
        )
    } else if (pageNo === 51) {
        return (
            <div>
                <Frame47 />
            </div>
        )
    } else if (pageNo === 52) {
        return (
            <div>
                <Frame48 />
            </div>
        )
    } else if (pageNo === 53) {
        return (
            <div>
                <Frame49 />
            </div>
        )
    } else if (pageNo === 54) {
        return (
            <div>
                <Frame50 />
            </div>
        )
    }
}

export default Episode2_MainPage